module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_buchung 4 ro.95a7dbc4.svg";